import { render } from "./modal.vue?vue&type=template&id=0fd4de31&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=0fd4de31&scoped=true&lang=scss"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd4de31"]])

export default __exports__